function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "usability",
  transform: "translate(0.05 0.05)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M10.312,32a.938.938,0,0,1-.937-.938V29.517c0-2.575-1.887-3.686-2.377-4.318a4.657,4.657,0,0,1-1.373-3.315V15.937a2.812,2.812,0,0,1,3.75-2.651V8.437a4.656,4.656,0,0,1-.642-.583l-3.164,1.9a2.866,2.866,0,0,1,.056.56A2.816,2.816,0,1,1,4.6,8.145l3.166-1.9A4.686,4.686,0,1,1,16.86,4.326l7.814.977a2.812,2.812,0,1,1-.233,1.86l-7.814-.977A4.716,4.716,0,0,1,15,8.437v1.1a2.809,2.809,0,0,1,2.813.556A2.811,2.811,0,0,1,22.4,11.449a2.811,2.811,0,0,1,3.849,2.614v7.162a10.371,10.371,0,0,1-1.089,4.612,6.869,6.869,0,0,0-.787,3.122v2.1a.938.938,0,0,1-.937.938Z",
  fill: "#17a7ec",
  stroke: "#17a7ec",
  strokeMiterlimit: 10,
  strokeWidth: 0.1
}));

function SvgUsability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.1,
    height: 32.1,
    viewBox: "0 0 30.1 32.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsability);
export default __webpack_public_path__ + "static/media/usability.fb9825d0.svg";
export { ForwardRef as ReactComponent };